import React from "react";
import ReactTooltip from "react-tooltip";
import { getMapTitle, getMapDisclaimer } from "../../service/textRetrieval";

import MutationMap from "./mutationMap";
import MutationMapBox from "./mutationMapBox";

const MapWithToolTip = ({
  textLiterals,
  variant = "ukvui",
  title = "Map of tracked variant occurrence",
  useMapBox = true,
}) => {
  const [tooltipContent, setTooltipContent] = React.useState("");
  const [mapDisclaimer, setMapDisclaimer] = React.useState("");
  const [rTitle, setRTitle] = React.useState("");
  React.useEffect(() => {
    setRTitle(getMapTitle(textLiterals));
    setMapDisclaimer(getMapDisclaimer(textLiterals));
  }, [textLiterals]);

  return useMapBox ? (
    <MutationMapBox
      title={rTitle ?? title}
      subtitle={mapDisclaimer}
      variant={variant}
    />
  ) : (
    <>
      <MutationMap
        title={rTitle ?? title}
        subtitle={mapDisclaimer}
        setTooltipContent={setTooltipContent}
        variant={variant}
      />
      <ReactTooltip>{tooltipContent}</ReactTooltip>
    </>
  );
};

export default MapWithToolTip;
